import React from 'react';
import fa from 'locales/fa.json';
import { faNumber } from 'utils/common.util';
import Link from 'next/link';
import { ConsultingConditionRoute } from 'services/routes';

const Footer: React.FC = () => {
  return (
    <footer>
      <div className="w-full text-white py-[40px] flex-col md:flex-row flex items-center justify-center bg-blue-9">
        <div className="flex-1 max-w-[300px] md:self-start p-[20px] mb-[20px]">
          <div className="font-bold text-[18px] mb-[16px]">{fa.footer.access}</div>

          <Link href={ConsultingConditionRoute()}>
            <a className="cursor-pointer my-[10px] text-white hover:text-blue-2 duration-300 block">
              {fa.footer.conditions}
            </a>
          </Link>
        </div>

        <div className="flex-1 max-w-[300px] border-t border-t-white50 md:border-t-0 md:border-r border-r-white50 p-[20px] mb-[20px]">
          <div className="font-bold text-[18px] mb-[16px]">تماس با ما</div>
          <div className="flex mt-[16px] text-[16px] justify-between">
            <div className="">شماره تماس: </div>
            <div className="">{faNumber('09302849802')}</div>
          </div>
          <div className="flex mt-[8px] text-[16px] justify-between">
            <div className=""> آی دی ایتا:</div>
            <a
              href="https://eitaa.com/s/sedaye_moshavere"
              target="_blank"
              rel="noreferrer"
              className="text-white"
            >
              sedaye_moshavere@
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
